window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.mailFormRepo = function () {
    var url = 'api/casinomailform';

    var post = function (model) {
        return fetch(url, {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(model)
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        post: post
    }

}();